import React, { useState, useEffect, Fragment } from 'react'

import smiley100 from './../../images/smiley/smiley-100-percent.svg'
import smiley66 from './../../images/smiley/smiley-66-percent.svg'
import smiley33 from './../../images/smiley/smiley-33-percent.svg'
import smiley0 from './../../images/smiley/smiley-0-percent.svg'
import '../../i18n';
import { useTranslation } from 'react-i18next';
import { sendConsumerResponse } from '../../api'

const UserRatings = ({ receipt }) => {
    const { t } = useTranslation();
    const [chosenSmiley, setChosenSmiley] = useState(null)
    const [closeRatings, setCloseRatings] = useState(false)
    const [ratingsAndWishesSubmitted, setRatingsAndWishesSubmitted] = useState(false);

    useEffect(() => {
        if (chosenSmiley) {
            const params = new URLSearchParams(window.location.search)
            const deviceCode = params.get('deviceCode')
            const timestamp = params.get('t')
            const orderId = receipt?.orderId;
            const ratingObj = {
                rating: chosenSmiley?.id,
                deviceCode,
                timestamp,
                orderId
            }
            sendConsumerResponse(ratingObj)
            setRatingsAndWishesSubmitted(true)
        }
    }, chosenSmiley)


    return (
        <Fragment>
            <div className={`rating ${chosenSmiley || closeRatings ? 'rating--close' : ''}`}>
                <div className="rating__container rating__container--nextpage">
                    {chosenSmiley && (
                        <div className="rating__thankyou">
                            {chosenSmiley && <img className="rating__thankyou-img" src={chosenSmiley.src} />}
                        </div>
                    )}

                    <div className="rating__header">
                        {t('rate_shopping')}
                    </div>

                    <div className="rating__emotions">
                        <img className="ratings__emotions-img" src={smiley100} onClick={() => { setChosenSmiley({ id: 100, src: smiley100 }) }} />
                        <img className="ratings__emotions-img" src={smiley66} onClick={() => { setChosenSmiley({ id: 66, src: smiley66 }) }} />
                        <img className="ratings__emotions-img" src={smiley33} onClick={() => { setChosenSmiley({ id: 33, src: smiley33 }) }} />
                        <img className="ratings__emotions-img" src={smiley0} onClick={() => { setChosenSmiley({ id: 0, src: smiley0 }) }} />
                    </div>

                    <div className="rating__send rating__send--notnow" onClick={() => setCloseRatings(true)}>
                        <span>{t('notNow')}</span>
                    </div>
                </div>
            </div>
            {ratingsAndWishesSubmitted &&
                <div className="rating__thankyou rating__thankyou--nobackground">
                    {chosenSmiley && <img className="rating__thankyou-img" src={chosenSmiley.src} />}
                </div>
            }
        </Fragment>
    )
}

export default UserRatings
